module.exports = __webpack_public_path__ + "img/Artboard_1.76e8263b.jpg";